import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import {createUseStyles} from "react-jss";
import {
  defaultFontSize,
  greenColor,
  normalFontWeight,
  orangeColor,
  primaryTextColor,
  redColor,
  rgba,
  smallFontSize
} from "~/theme";

export default function UILabel({brand, success, danger, warning, small, className, ...props}) {
  const classes = useStyles();

  return (
    <div className={cn(classes.root, {
      [classes.small]: small,

      [classes.brand]: brand,
      [classes.success]: success,
      [classes.warning]: warning,
      [classes.danger]: danger,
    }, className)} {...props}/>
  )
}

UILabel.propTypes = {
  small: PropTypes.bool,
  brand: PropTypes.bool,
  success: PropTypes.bool,
  danger: PropTypes.bool,
  warning: PropTypes.bool,
};

const useStyles = createUseStyles({
  root: {
    display: 'inline-block',
    padding: [[4, 10]],
    color: primaryTextColor,
    fontSize: defaultFontSize,
    fontWeight: normalFontWeight,
    backgroundColor: rgba('#ccc', 0.05),
    border: [[1, 'solid', rgba('#ccc', 0.75)]],
    borderRadius: 6,
  },

  success: {
    backgroundColor: rgba(greenColor, 0.05),
    borderColor: rgba(greenColor, 0.75),
    color: greenColor,
  },

  warning: {
    backgroundColor: rgba(orangeColor, 0.05),
    borderColor: rgba(orangeColor, 0.75),
    color: orangeColor,
  },

  danger: {
    backgroundColor: rgba(redColor, 0.05),
    borderColor: rgba(redColor, 0.75),
    color: redColor,
  },

  small: {
    fontSize: smallFontSize,
    padding: [[2, 8]],
  },
});
